import styled from 'styled-components';

export const RecoverAccountStyled = styled.div`
    width: 100%;
    height: 100%;
    padding: 0 3.25rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
`;

export const FormStyled = styled.form`
    margin-top: 1.5625rem;
    margin-bottom: 3.1258rem;
    width: 90%;
    display: grid;
    row-gap: 1.5625rem;
    justify-items: center;
    >p{
        color: #818181;
        font-size: 1.125rem;
        text-align: center;

    }
    >span{
        color: #818181;
        font-size: .875rem;
        text-align: center;
        margin-bottom: 2.5625rem
    }
`;